
import { defineComponent, onMounted, ref } from "vue";
import CryptoJS from "crypto-js";

export default defineComponent({
    setup() {
        const decryptedEmail = ref("");

        onMounted(() => {
            getEmail();
        });

        function getEmail() {
            // const ciphertext = CryptoJS.AES.encrypt(
            //     "mailto:sacha.goldman@mail.utoronto.ca",
            //     "poaidsfjiudsafhouWHQe7y91378r"
            // ).toString();

            // console.log(ciphertext);

            decryptedEmail.value = CryptoJS.AES.decrypt(
                "U2FsdGVkX1+Ne4PmmAwsf0HuIfskaull+LGFEIJhmSbs8SCCH7dsqBo/Ye1aAQGnWHE9UH+vcUmEaGaZlhoPRg==",
                "poaidsfjiudsafhouWHQe7y91378r"
            ).toString(CryptoJS.enc.Utf8);
        }

        return { decryptedEmail };
    },
});
